import React, { useEffect, useRef, useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import { Box, Typography, useTheme } from "@mui/material";
import BottomTabbar from "../../../layout/DriverLayout/BottomTabbar";
import RowsIcon from "../../../../media/images/icons/rows-icons";
import ButtonTabbar from "../../../components/ButtonTabbar";
import ActiveFeright from "./ActiveFeright";
import CompleteCargos from "./CompleteCargos";
import CanceledCargos from "./CanceledCargos";

export default function ManageFreights() {
  const theme = useTheme();
  const [tabIndex, setTabIndex] = useState(0);

  const tabbuttons = [
    {
      title: "بارهای فعال",
    },
    {
      title: "تکمیل‌شده",
    },
    {
      title: "لغو‌شده",
    },
  ];

  const [hasScroll, setHasScroll] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 700,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            مدیریت بارها{" "}
          </Typography>
        }
        hasScroll={hasScroll}
      />
      <Box
        ref={divRef}
        sx={{
          flex: 1,
          overflow: "auto",
          paddingX: "8px",
          paddingY: "8px",
        }}
      >
        <Box
          sx={{
            boxShadow: "0px 4px 8px 0px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            backgroundColor: "background.default",
            padding: "16px",
            borderColor: "bgColor.blueGrey100",
            borderWidth: "2px",
            borderStyle: "solid",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
              gap: "8px",
            }}
          >
            <RowsIcon size={32} color={theme.palette.primary.main} />
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "20px",
              }}
            >
              مدیریت بارها
            </Typography>
          </Box>
          <ButtonTabbar
            activeIndex={tabIndex}
            handleChangeTab={(index) => setTabIndex(index)}
            buttons={tabbuttons}
          />
        </Box>
        <GetStepContent stepIndex={tabIndex} />
      </Box>
    </>
  );
}

function GetStepContent({ stepIndex }: { stepIndex: number }) {
  switch (stepIndex) {
    case 0:
      return <ActiveFeright />;

    case 1:
      return <CompleteCargos />;

    case 2:
      return <CanceledCargos />;
    default:
      return <></>;
      break;
  }
}
